<template>
  <div>
    <base-title
      :title="'Pesquisa de satisfação'"
      :subtitle="StringLanguage.reports"
      :link="'relatorios'"
    >
      <base-button
        @click="drawers.options.open = !drawers.options.open"
        text="Opções"
        design="two"
        :class="!!isMobile && 'reverse w-100 mb_15'"
      />
      <base-button
        @click="drawers.rating.open = !drawers.rating.open"
        text="Filtrar avaliações"
        :class="!!isMobile ? 'reverse w-100 mb_15' : 'ml_15'"
        design="two"
      >
        <p class="filter" v-if="!isMobile">
          <i class="fal fa-sliders-h"></i>
        </p>
        <p class="filter" v-else>Filtrar avaliações</p>
      </base-button>
      <base-button
        @click="drawers.period.open = !drawers.period.open"
        title="Definir periodo"
        :class="!!isMobile ? 'reverse w-100' : 'ml_15'"
        design="two"
      >
        <p class="filter" v-if="!isMobile">
          <i class="fal fa-calendar-day"></i>
        </p>
        <p class="filter" v-else>Filtrar intervalo</p>
      </base-button>
    </base-title>

    <base-empty
      v-if="
        (result.total == 0 ||
          result.total == 'undefined' ||
          result.total == null) &&
        !loading
      "
      title="Você ainda não tem avaliações."
      message="Todas as avaliações feitas pelos seus clientes irão aparecer por aqui."
    />

    <div class="d-flex justify-between align-center flex-wrap" v-if="!!result">
      <base-box
        :class="{
          'd-flex': true,
          'flex-column': true,
          totalizer: true,
          global: true,
          negative: result.avgGlobal > 0 && result.avgGlobal <= 2,
        }"
      >
        <div class="d-flex mb_20 align-center">
          <p>{{ getFormattedAverage(result.avgGlobal) }}</p>
          <star-rating
            :rating="result.avgGlobal"
            :showHalf="true"
            :size="isMobile ? '1.5em' : '2.2em'"
          />
        </div>
        <p>Avaliação geral</p>
      </base-box>
      <base-box
        :class="{
          'd-flex': true,
          'flex-column': true,
          totalizer: true,
          negative: result.avgService > 0 && result.avgService <= 2,
        }"
      >
        <div class="d-flex mb_25 align-center">
          <p>{{ getFormattedAverage(result.avgService) }}</p>
          <star-rating
            :rating="result.avgService"
            :showHalf="true"
            :size="isMobile ? '1em' : '1.7em'"
            :color="
              result.avgService == 0 || result.avgService > 2 ? '#8e8e90' : ''
            "
          />
        </div>
        <p>{{ `${!isMobile ? 'Avaliação ' : ''}atendimento` }}</p>
      </base-box>
      <base-box
        :class="{
          'd-flex': true,
          'flex-column': true,
          totalizer: true,
          negative: result.avgOrder > 0 && result.avgOrder <= 2,
        }"
      >
        <div class="d-flex mb_25 align-center">
          <p>{{ getFormattedAverage(result.avgOrder) }}</p>
          <star-rating
            :rating="result.avgOrder"
            :showHalf="true"
            :size="isMobile ? '1em' : '1.7em'"
            :color="
              result.avgOrder == 0 || result.avgOrder > 2 ? '#8e8e90' : ''
            "
          />
        </div>
        <p>{{ `${!isMobile ? 'Avaliação ' : ''}pedido` }}</p>
      </base-box>
      <base-box
        :class="{
          'd-flex': true,
          'flex-column': true,
          totalizer: true,
          negative: result.avgDelivery > 0 && result.avgDelivery <= 2,
        }"
      >
        <div class="d-flex mb_25 align-center">
          <p>{{ getFormattedAverage(result.avgDelivery) }}</p>
          <star-rating
            :rating="result.avgDelivery"
            :showHalf="true"
            :size="isMobile ? '1em' : '1.7em'"
            :color="
              result.avgDelivery == 0 || result.avgDelivery > 2 ? '#8e8e90' : ''
            "
          />
        </div>
        <p>{{ `${!isMobile ? 'Avaliação ' : ''}entrega` }}</p>
      </base-box>
    </div>

    <p class="title-rating mb_30" v-if="!empty">Suas avaliações</p>

    <base-box v-if="!empty">
      <div class="d-flex justify-between align-center mb_5 flex-wrap">
        <div class="d-flex align-center">
          <base-label text="Buscar pedido" class="mb_0" />
          <span class="tag period" v-if="!noPeriod && !isMobile">
            {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
            <i @click="removePeriod" class="fal fa-times remove-filter"></i>
          </span>
        </div>
        <span class="tag">{{ result.total }} ocorrências</span>

        <span class="tag period" v-if="!noPeriod && !!isMobile">
          {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
          <i @click="removePeriod" class="fal fa-times remove-filter"></i>
        </span>
      </div>

      <base-input
        :placeholder="'Procure por número do pedido, cliente ou telefone.'"
        class="w-100 mb_0"
        :class="{ mt_10: !!isMobile }"
        v-model="term"
        search
        @keyup="!!isTyping ? (loading = true) : (loading = false)"
        @input="isTyping = true"
      />
      <div v-if="isMobile && showTags" class="tags-mobile mt_15">
        <p class="tag">{{ result.total }} ocorrências</p>
        <p class="tag" v-if="!noPeriod" @click="removePeriod">
          {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
        </p>
      </div>
    </base-box>

    <div v-if="loading" class="search-loading">
      <base-loading />
    </div>

    <div class="row d-flex flex-wrap" id="rating" v-else>
      <div
        v-for="(item, index) in result.data"
        :key="index"
        class="col-lg-6 col-md-6 col-xs-12"
      >
        <base-box class="card-rating">
          <div>
            <div class="d-flex align-start justify-between mb_35">
              <div>
                <p class="order-number mb_5">
                  Pedido #{{ item.id_order_customer }}
                </p>
                <p>
                  {{
                    dayjs(new Date(item.order_created_at)).format(
                      'DD/MM/YYYY [às] HH:mm:ss'
                    )
                  }}
                </p>
              </div>
              <div
                :class="{
                  'd-flex': true,
                  'text-right': true,
                  'order-average': true,
                  negative: item.rating_average && item.rating_average <= 2,
                }"
              >
                <p>{{ getFormattedAverage(item.rating_average) }}</p>
                <i
                  :class="{
                    fas: !!Number.isInteger(item.rating_average),
                    fad: !Number.isInteger(item.rating_average),
                    'fa-star': true,
                    'fa-star-half': !Number.isInteger(item.rating_average),
                  }"
                ></i>
              </div>
            </div>
            <hr class="line" />
            <div
              v-for="(category, indexCategory) in categoryRating"
              :key="indexCategory"
              class="align-start justify-between line-section"
            >
              <div class="d-flex mb_5 text-right rating-category">
                <p>{{ category }}</p>
                <star-rating
                  :rating="
                    item.answer.find((a) => a.id_question == indexCategory + 1)
                      .value
                  "
                  :size="isMobile ? '1.2em' : '1.5em'"
                />
              </div>
              <div
                class="d-flex align-start justify-start flex-wrap"
                v-if="
                  !!item.answer.find((a) => a.id_question == indexCategory + 1)
                    .tags.length
                "
              >
                <span
                  v-for="(itemCategory, indexItem) in item.answer.find(
                    (a) => a.id_question == indexCategory + 1
                  ).tags"
                  :key="indexItem"
                  class="category-rating-item mt_10"
                  >{{ getTagLabel(itemCategory) }}
                </span>
              </div>
              <p v-else class="mt_35 category-empty">
                Este quesito da avaliação não foi detalhado.
              </p>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div
              class="align-start justify-between rating-comment"
              :class="!!isMobile ? 'mb_15' : 'mb_30'"
            >
              <p class="mb_20">Comentário</p>
              <div>
                <p v-if="item.answer.find((a) => a.id_question == 4)">
                  "{{
                    (
                      item.answer.find((a) => a.id_question == 4) || {
                        comment: '',
                      }
                    ).comment
                  }}"
                </p>
                <p v-else>Não há comentários neste pedido.</p>
              </div>
            </div>
            <div class="d-flex align-center">
              <base-button
                text="Detalhes do cliente"
                design="two"
                class="w-100 mr_15"
                @click="customerDetail(item.user.phone)"
              />
              <base-button
                text="Detalhes do pedido"
                design="two"
                class="w-100"
                @click="orderDetail(item.order_id, 'detail')"
              />
            </div>
          </div>
        </base-box>
      </div>
    </div>

    <infinite-loading spinner="wavedots" @infinite="infiniteHandler">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>

    <filter-period
      :open="drawers.period.open"
      :close="drawers.period.close"
      @filter="filterPeriod"
      defaultOption="1"
      :maxCustomRange="0"
    />

    <base-drawer
      title="Opções"
      :open="drawers.options.open"
      :close="drawers.options.close"
      @onClose="drawers.options.ratingStore = false"
    >
      <base-card>
        <div class="d-flex">
          <div
            class="option"
            @click="drawers.options.ratingStore = !drawers.options.ratingStore"
            v-if="!drawers.options.ratingStore"
          >
            <i class="fal fa-star fs-18" />
            <p>Nota da loja</p>
          </div>
        </div>

        <div v-if="drawers.options.ratingStore">
          <base-question text="Sobre a loja" class="mb_20" />
          <base-radio
            :value="showRatingStore"
            label="Mostrar nota na loja online"
            family="rating-store"
            class="mb_15"
            @change="showRatingStore = true"
            :option="true"
          />
          <base-radio
            :value="showRatingStore"
            label="Não mostrar nota na loja online"
            family="rating-store"
            @change="showRatingStore = false"
            :option="false"
          />
        </div>
      </base-card>

      <template v-slot:footer v-if="drawers.options.ratingStore">
        <base-button text="Salvar" class="w-100" @click="handleRatingKey()" />
      </template>
    </base-drawer>

    <base-drawer
      title="Filtrar Avaliações"
      :open="drawers.rating.open"
      :close="drawers.rating.close"
    >
      <base-card>
        <div>
          <base-question
            text="Filtrar avaliações por"
            class="group-title mb_20"
          />
          <div class="rating-tag-box mb_10">
            <span
              v-for="(tag, index) in ratingTags"
              :key="index"
              :class="{ 'rating-tag': true, mb_10: true, active: tag.active }"
              @click="changeFilterTag(tag, index)"
            >
              <p>{{ tag.label }}</p>
              <i class="fas fa-star star"></i>
            </span>
          </div>

          <p class="results-text">{{ result.total }} encontrados</p>
        </div>
      </base-card>

      <base-card>
        <div>
          <base-question text="Comentários" class="group-title mb_20" />
          <base-radio
            label="Todos"
            :family="id"
            v-model="ratingComents"
            :option="'all'"
            class="mb_15"
          />
          <base-radio
            label="Sem comentários"
            :family="id"
            v-model="ratingComents"
            :option="'no_comments'"
            class="mb_15"
          />
          <base-radio
            label="Com comentários"
            :family="id"
            v-model="ratingComents"
            :option="'with_comments'"
            class="mb_15"
          />
        </div>
      </base-card>

      <template v-slot:footer>
        <base-button text="Filtrar" class="w-100" @click="filterRating" />
      </template>
    </base-drawer>

    <!-- Customer drawer -->
    <base-drawer
      :open="drawers.customer.open"
      @onOpen="drawers.customer.show = true"
      @onClose="drawers.customer.show = false"
      :title="'Ver cliente'"
    >
      <base-tabs
        :tabs="modeTabs"
        :tabActived="tabActived"
        @change="changeMode"
        class="drawer-tabs"
      />

      <sales-customer
        v-if="drawers.customer.show && tabActived == 'dados'"
        :configurations="configurations"
        :key="drawers.customer.index"
        :customer="selectedCustomer"
      />

      <div v-if="tabActived == 'pedidos'">
        <base-card
          v-for="(order, indexOrder) in resultOrder.data"
          :key="indexOrder"
          class="drawer-box-order"
        >
          <div class="d-flex align-start justify-between mb_25">
            <div>
              <p class="drawer-order-number mb_5">
                Pedido #{{ order.order_id }}
              </p>
              <p>
                {{
                  dayjs(new Date(order.created_at)).format(
                    'DD/MM/YYYY [às] HH:mm:ss'
                  )
                }}
              </p>
            </div>
            <div
              :class="{
                'd-flex': true,
                'text-right': true,
                'drawer-order-average': true,
                negative: order.rating_average && order.rating_average <= 2,
              }"
            >
              <p>{{ getFormattedAverage(order.rating_average) }}</p>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div
            class="d-flex justify-end show-more"
            @click="orderDetail(order.id, '')"
          >
            VER MAIS
          </div>
          <div />
        </base-card>

        <infinite-loading spinner="wavedots" @infinite="infiniteHandlerOrders">
          <div slot="no-more"></div>
          <div slot="no-results">Sem resultado</div>
        </infinite-loading>
      </div>
    </base-drawer>

    <!-- Order drawer -->
    <base-drawer
      :open="drawers.order.open"
      :close="drawers.order.close"
      :title="getTitleOrderDrawer()"
      :styleTitle="
        drawers.order.origin != 'detail' ? 'flex-direction: row-reverse;' : ''
      "
      :closebtn="
        drawers.order.origin != 'detail'
          ? 'far fa-chevron-left'
          : 'far fa-times'
      "
    >
      <orders-detail
        :reportRating="true"
        v-if="targetOrder.id"
        :order="targetOrder"
        :catalog="catalog"
        :key="targetOrderReload"
      />
    </base-drawer>
  </div>
</template>
<script>
import Builder from 'easyjs/lib/Schema/Components/Builder';
import { DateTime } from 'easyjs/lib/Tools';
import { Role } from 'easyjs/lib/Role/Group';
import { UserFlag } from 'easyjs/lib/Schema/Account/UserFlag';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import BaseRadio from '@/components/Radio';
import BaseTitle from '@/components/Title';
import StarRating from '@/components/StarRating';
import BaseTabs from '@/components/Tabs';
import BaseEmpty from '@/components/Empty';

import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseButton from '@/components/Button';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseCheckbox from '@/components/Checkbox';
import BaseQuestion from '@/components/Question';
import BaseSelect from '@/components/Select';
import BaseLabel from '@/components/Label';
import BaseLoading from '@/components/Loading';
import SalesCustomer from '@/containers/Sales/SalesCustomer/SalesCustomer';
import OrdersDetail from '@/containers/Orders/OrdersDetail';

import FilterPeriod from '@/containers/FilterPeriod';
import ApiReports from '@/api/reports';
import CustomerApi from '@/api/customer';
import OrderApi from '@/api/order';
import CatalogAPI from '@/api/catalog';
import StoreAPI from '@/api/store';
import SurveyAPI from '@/api/survey';

import { getXAPIEnv } from '@/plugins/account';
import Utils from '@/utils';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');
dayjs.extend(customParseFormat);

export default {
  data() {
    return {
      empty: true,
      tabActived: 'dados',
      targetOrderReload: false,
      targetOrder: {},
      modeTabs: [
        { name: 'Dados', value: 'dados' },
        { name: 'Pedidos', value: 'pedidos' },
      ],
      categoryRating: ['Atendimento', 'Pedido', 'Entrega'],
      loading: false,
      Utils,
      dayjs,
      Role,
      showTags: false,
      isTyping: false,
      page: 1,
      pageOrders: 1,
      size: 15,
      term: '',
      showRatingStore: false,
      drawers: {
        period: {
          open: false,
          close: false,
        },
        rating: {
          open: false,
          close: false,
        },
        customer: {
          open: false,
          close: false,
          show: false,
        },
        order: {
          open: false,
          close: false,
          show: false,
          origin: 'detail',
        },
        options: {
          open: false,
          close: false,
          show: false,
          ratingStore: false,
        },
      },
      result: {},
      keys: {},
      resultOrder: {},
      aSurvey: {},
      tags: [],
      targetOrder: {},
      targetOrderReload: false,
      period: [
        dayjs(new Date('1901-01-01')).format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
        dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
      ],
      noPeriod: true,
      sort: 0,
      selectedSort: 0,
      sortData: {
        created_at: {
          order: 'desc',
        },
      },
      selectedCustomer: {},
      ratingTags: [
        { label: 'Todas', active: true, min: 0, max: 5 },
        { label: '1,0', active: true, min: 0, max: 1 },
        { label: '1,0 - 2,0', active: true, min: 1, max: 2 },
        { label: '2,0 - 3,0', active: true, min: 2, max: 3 },
        { label: '3,0 - 4,0', active: true, min: 3, max: 4 },
        { label: '4,0 - 5,0', active: true, min: 4, max: 5 },
        { label: '5,0', active: true, min: 5, max: 5 },
      ],
      ratingComents: 'all',
      catalog: '',
      filtersData: [],
    };
  },
  components: {
    BaseRadio,
    BaseTitle,
    StarRating,
    BaseTabs,
    BaseBox,
    BaseInput,
    BaseButton,
    BaseEmpty,
    BaseDrawer,
    BaseCard,
    BaseCheckbox,
    BaseQuestion,
    BaseSelect,
    BaseLabel,
    BaseLoading,
    FilterPeriod,
    InfiniteLoading,
    SalesCustomer,
    OrdersDetail,
  },
  methods: {
    handleRatingKey() {
      return StoreAPI.storeConfiguration(
        {
          keys: {
            showRating: this.showRatingStore,
          },
        },
        false
      )
        .then((response) => {
          if (response.getErrors([]).length === 0) {
            this.$store.dispatch('store/getConfigurations');
            this.drawers.options.close = !this.drawers.options.close;
          }
        })
        .catch((err) => {
          console.log(err);
          alert(StringLanguage.saveError);
        });
    },
    getTitleOrderDrawer() {
      if (this.drawers.order.origin == 'detail')
        return `${StringLanguage.order} #${this.targetOrder.order_id} - Finalizado`;

      return `Detalhamento do pedido - #${this.targetOrder.order_id}`;
    },
    getFormattedAverage(value) {
      return value ? parseFloat(value).toFixed(1).replace('.', ',') : 0;
    },
    getTagLabel(id) {
      const item = this.tags.find((tag) => tag.id == id);
      return item ? item.label['pt-br'] : '';
    },
    changeFilterTag(tag, index) {
      if (index === 0) {
        this.ratingTags = this.ratingTags.map((item) => ({
          ...item,
          active: !tag.active,
        }));
        return;
      }
      if (this.ratingTags[0].active && tag.active) {
        this.ratingTags[0].active = false;
        tag.active = !tag.active;
        return;
      }

      tag.active = !tag.active;
      const ratingTagsItems = this.ratingTags.filter((_, i) => i > 0);

      if (!ratingTagsItems.some((tag) => !tag.active)) {
        this.ratingTags[0].active = true;
      }
    },
    formatDate(date) {
      const ds = date.split('T');
      return dayjs(dayjs(`${ds[0]} ${ds[1].split('-')[0]}`)).format(
        'HH:mm [de] DD/MM/YYYY'
      );
    },
    formatCreated(date) {
      const ds = date.split('T');
      return dayjs(dayjs(`${ds[0]} ${ds[1].split('-')[0]}`)).format(
        'DD/MM/YYYY [de] HH:mm'
      );
    },
    search(reset = true) {
      const self = this;
      return new Promise((resolve) => {
        if (reset) {
          this.result.data = [];
          this.result.avgGlobal = 0;
          this.result.avgService = 0;
          this.result.avgOrder = 0;
          this.result.avgDelivery = 0;
          this.page = 1;
          this.loading = true;
        }

        ApiReports.reports(this.esDataFilter).then((response) => {
          if (response.data[0]) {
            const data = response.data[0];

            let avgGlobal = 0;
            let avgService = 0;
            let avgOrder = 0;
            let avgDelivery = 0;

            const avgValue = data.hits.map((item) => {
              item._source.answer.map((item) => {
                if (item.value > 0) return item.value;
              });
              return avgValue;
            });

            if (response.data[1]) {
              const avgs = response.data[1];

              avgGlobal = avgs.total.value;
              avgService = avgs.avgs.service.total.value;
              avgOrder = avgs.avgs.order.total.value;
              avgDelivery = avgs.avgs.delivery.total.value;
            }

            if (data.hits.length > 0 && avgGlobal) {
              const result = {
                total: data.total.value,
                avgGlobal,
                avgService,
                avgOrder,
                avgDelivery,
              };

              self.result = { ...self.result, ...result };

              !self.result.data || reset ? (self.result.data = []) : '';

              self.page += 1;

              data.hits.forEach((item) => {
                self.result.data.push(item._source);
              });

              resolve(true);
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        });
        this.loading = false;
        self.$forceUpdate();
      });
    },
    searchOrders(reset = true) {
      const self = this;

      return new Promise((resolve) => {
        if (reset) {
          this.resultOrder.total = 0;
          this.resultOrder.data = [];
          this.pageOrders = 1;
        }

        const esFilter = {
          query: [
            {
              index: 'report-orders',
              type: 'query',
              size: this.size,
              from: (this.pageOrders - 1) * this.size,
              sort: [
                {
                  created_at: {
                    order: 'desc',
                  },
                },
              ],
              queries: [
                {
                  range: {
                    created_at: {
                      gte: this.period[0],
                      lte: this.period[1],
                    },
                  },
                },
                {
                  bool: {
                    should: [
                      {
                        match: {
                          status: 4,
                        },
                      },
                      {
                        match: {
                          status: -1,
                        },
                      },
                    ],
                  },
                },
                {
                  nested: {
                    path: 'payers',
                    query: {
                      query_string: {
                        query: `*${this.selectedCustomer.phone}*`,
                        fields: ['payers.user.phone'],
                      },
                    },
                  },
                },
              ],
            },
          ],
        };

        ApiReports.reports(esFilter).then((response) => {
          if (response.data[0]) {
            const data = response.data[0];

            if (data.hits.length > 0) {
              const result = {
                total: data.total.value,
              };
              self.resultOrder = { ...result };
              !self.resultOrder.data || reset
                ? (self.resultOrder.data = [])
                : '';

              self.pageOrders += 1;

              data.hits.forEach((item) => {
                self.resultOrder.data.push(item._source);
              });

              resolve(true);
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        });
        self.$forceUpdate();
      });
    },
    infiniteHandler($state) {
      this.search(false).then((result) => {
        if (result) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    infiniteHandlerOrders($state) {
      this.searchOrders(false).then((result) => {
        if (result) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    filterPeriod(period) {
      this.noPeriod = false;
      this.period = period.periods;
      period.periods[0] = dayjs(period.periods[0]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      period.periods[1] = dayjs(period.periods[1]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      this.search();
      this.drawers.period.close = !this.drawers.period.close;
    },
    filterRating() {
      this.filtersData = [];

      for (const tag of this.ratingTags) {
        if (tag.active) {
          this.filtersData.push({
            range: {
              rating_average: {
                gte: tag.min,
                lte: tag.max,
              },
            },
          });
        }
      }

      this.search();
      this.drawers.rating.close = !this.drawers.rating.close;
    },
    removePeriod() {
      this.noPeriod = true;
      this.period = [
        dayjs(new Date('1901-01-01')).format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
        dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
      ];
      this.search();
    },
    async customerDetail(phone) {
      const response = await CustomerApi.GetFromPhone(phone, '', false);

      if (response.getErrors([]).length > 0) {
        return;
      }
      const data = response.getData([]);
      const customer = data || [];

      this.getAddresses(customer[0].id);
      this.selectedCustomer = customer[0];
      this.tabActived = 'dados';
      this.drawers.customer.open = !this.drawers.customer.open;
    },
    async orderDetail(orderId, origin) {
      const orderResponse = await OrderApi.get(orderId, false);
      const { order } = orderResponse.getData({ order: null });

      this.targetOrder = order;
      this.drawers.order.open = !this.drawers.order.open;
      this.drawers.order.origin = origin;
      this.targetOrderReload = !this.targetOrderReload;
    },
    async getAddresses(userId, index = '') {
      await CustomerApi.GetConfigurations(userId, false).then(
        (configurations) => {
          const addressesData = configurations.getData({
            addresses: [],
          }).addresses;
          this.$set(this.selectedCustomer, 'addresses', addressesData);

          const environmentAlias = getXAPIEnv();
          const { flags, annotations } = configurations.getData({
            flags: { [environmentAlias]: 0 },
          });
          const userFlags = flags[environmentAlias];

          if (annotations && annotations.length) {
            this.annotationsList = annotations
              .map((annotation) => annotation.annotation)
              .join('\n');
          }

          this.hasOrder =
            (userFlags & UserFlag.HAS_ORDER) == UserFlag.HAS_ORDER;
          this.hasAnnotation =
            (userFlags & UserFlag.HAS_ANNOTATION) == UserFlag.HAS_ANNOTATION;
          this.isBirthday =
            (userFlags & UserFlag.IS_BIRTHDAY) == UserFlag.IS_BIRTHDAY;
          this.hasIndicator =
            !this.hasOrder || this.hasAnnotation || this.isBirthday;

          if (addressesData.length > 0) {
            this.selectedDeliveryAddress = 0;
          }

          if (index != '') {
            this.selectedDeliveryAddress = index;
          }

          this.$set(
            this.selectedCustomer,
            'annotation',
            configurations.getData({ annotations: [null] }).annotations[0]
          );
        }
      );
    },
    removeAddress(id) {
      AccountApi.deleteUserAddress(id, this.selectedCustomer.id).then(
        (response) => {
          if (response.getErrors([]).length > 0) {
            alert('Ocorreu um problema com o processo.');
            return false;
          }

          this.getAddresses(this.selectedCustomer.id);
        }
      );
    },
    changeMode(sMode) {
      this.tabActived = sMode;
      if (sMode == 'pedidos') this.searchOrders();
    },
    getCatalog() {
      CatalogAPI.catalogCatalog().then((catalogResponse) => {
        if (catalogResponse) {
          this.catalog = Builder.mountSchema(
            catalogResponse.getData({ type: 'catalog' })
          );
          Builder.executeOnSchema(this.catalog, function (item) {
            item.new = false;
            item.quantity = 0;
          });
          return this;
        }
      });
    },
    verifyEmpty() {
      const esFilter = {
        query: [
          {
            index: 'report-rating-orders',
            type: 'query',
            queries: [
              {
                range: {
                  created_at: {
                    gte: dayjs(new Date('1901-01-01')).format(
                      'YYYY-MM-DDTHH:mm:ssZ[Z]'
                    ),
                    lte: dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                  },
                },
              },
            ],
          },
        ],
      };

      ApiReports.reports(esFilter).then((response) => {
        if (response.data[0]) {
          const data = response.data[0];

          if (data.hits.length > 0) {
            this.empty = false;
          }
        }
      });
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      configurations: (state) => state.store.configurations,
    }),
    esDataFilter() {
      const queries = [
        {
          range: {
            created_at: {
              gte: this.period[0],
              lte: this.period[1],
            },
          },
        },
      ];

      if (this.term != '') {
        const termIsNumber = /^\d+$/.test(this.term);

        if (termIsNumber) {
          if (this.term.length <= 7) {
            queries.push({
              query_string: {
                query: `*${this.term}*`,
                fields: ['id_order_customer'],
              },
            });
          } else {
            queries.push({
              query_string: {
                query: `*${this.term.toLowerCase()}*`,
                fields: ['user.phone'],
              },
            });
          }
        } else {
          // transforma o nome em caixa baixa e substitui os espaços por '*'
          const queryName = this.term.toLowerCase().replace(/\s/g, '*');

          queries.push({
            query_string: {
              query: `*${queryName}*`,
              fields: ['user.name'],
            },
          });
        }
      }

      if (this.ratingComents == 'with_comments') {
        queries.push({
          bool: {
            must: [
              {
                exists: {
                  field: 'comment',
                },
              },
            ],
            must: [
              {
                wildcard: {
                  comment: '*',
                },
              },
            ],
          },
        });
      } else if (this.ratingComents == 'no_comments') {
        queries.push({
          bool: {
            must: [
              {
                exists: {
                  field: 'comment',
                },
              },
            ],
            must_not: [
              {
                wildcard: {
                  comment: '*',
                },
              },
            ],
          },
        });
      }

      const filters = [];
      !!this.filtersData.length &&
        this.filtersData.map((filter) => {
          filters.push(filter);
        });
      !!filters.length && queries.push({ bool: { should: filters } });

      return {
        query: [
          {
            index: 'report-rating-orders',
            type: 'query',
            size: this.size,
            from: (this.page - 1) * this.size,
            sort: this.sortData,
            queries,
          },
          {
            index: 'report-rating-orders',
            type: 'aggs',
            queries,
            aggs: {
              rating_total: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: this.period[0],
                      to: this.period[1],
                    },
                  ],
                },
              },
              total: { avg: { field: 'rating_average' } },
              avgs: {
                nested: {
                  path: 'answer',
                },
                aggs: {
                  service: {
                    filter: {
                      bool: {
                        must: [
                          { term: { 'answer.id_question': { value: 1 } } },
                        ],
                      },
                    },
                    aggs: { total: { avg: { field: 'answer.value' } } },
                  },
                  order: {
                    filter: {
                      bool: {
                        must: [
                          { term: { 'answer.id_question': { value: 2 } } },
                        ],
                      },
                    },
                    aggs: { total: { avg: { field: 'answer.value' } } },
                  },
                  delivery: {
                    filter: {
                      bool: {
                        must: [
                          { term: { 'answer.id_question': { value: 3 } } },
                        ],
                      },
                    },
                    aggs: { total: { avg: { field: 'answer.value' } } },
                  },
                },
              },
            },
          },
        ],
      };
    },
  },
  watch: {
    term: Utils.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping(value) {
      if (!value) {
        this.search();
      }
    },
  },
  mounted() {
    const self = this;
    StoreAPI.storeGetConfiguration().then((response) => {
      this.showRatingStore = response.getData().keys.showRating;
    });
  },
  created() {
    this.getCatalog();
    this.verifyEmpty();
    SurveyAPI.GetSurvey().then((response) => {
      this.aSurvey = response.getData({ questions: [] });
      this.tags = this.aSurvey.questions
        .filter((a) => a.type == 'RATING')
        .map((a) => a.configs.map((z) => z.tags).flat())
        .flat();
    });
    this.id =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
  },
};
</script>
<style scoped>
.card-rating {
  margin-bottom: 20px;
  height: 97%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (min-width: 991px) {
  #rating > .col-lg-6:nth-child(odd),
  #rating > .col-md-6:nth-child(odd) {
    padding-right: 10px;
  }
  #rating > .col-lg-6:nth-child(even),
  #rating > .col-md-6:nth-child(even) {
    padding-left: 10px;
  }
}
.option {
  background: var(--box-up);
  padding: 45px;
  border-radius: 5px;
  color: #8c8c8c;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 50%;
  cursor: pointer;
}
.option:hover {
  background: #4b4f54;
}
.option:nth-child(1n) {
  margin-right: 7.5px;
}
.option:nth-child(2n) {
  margin-left: 7.5px;
  margin-right: 0;
}
.option i {
  margin-bottom: 20px;
}
.card.drawer-box-order {
  padding-left: 15px;
  padding-right: 15px;
}
.empty > div {
  width: 264px;
  height: 205px;
  background: #8b8b8b 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 0.4;
}
.empty > p {
  font-size: 2em;
  font-family: 'Rubik', sans-serif;
  color: #999999;
}
.empty > span {
  font-size: 1.8em;
  font-family: 'Lato', sans-serif;
  color: #999999;
}
.results-text {
  text-align: left;
  font-size: 1.2em;
  color: #aaaaab;
}
.rating-tag-box {
  display: flex;
  flex-wrap: wrap;
}
.rating-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-right: 10px;
  border: 1px solid #605850;
  border-radius: 0px 0px 5px 5px;
  background-color: transparent;
  width: max-content;
  color: var(--alert-text);
  cursor: pointer;
}
.rating-tag > p {
  font-weight: bold;
  font-size: 1.4em;
}
.rating-tag > i {
  margin-left: 5px;
  font-size: 1.2em;
}
.rating-tag.active {
  background: #ffcc99db;
  border-color: #ffcc99db;
  color: var(--alert-text);
}
.order-number {
  font-weight: bold;
  font-size: 2em !important;
  color: #bfbfbf !important;
}
.order-number + p {
  font-size: 1.2em;
  color: #999999;
  opacity: 0.7;
}
.order-average {
  font-size: 1.8em;
  font-weight: bold;
  color: #ffb366;
}
.order-average > i {
  margin-left: 5px;
}
.order-average.negative {
  color: #e25569;
}
.rating-category {
  align-items: baseline;
}
.rating-category > p {
  color: #aaaaab;
  font-size: 1.4em;
  font-weight: bold;
  margin-right: 10px;
}
.category-empty {
  font-size: 1.2em;
  color: #999999;
}
.category-rating-item {
  width: max-content;
  background: #45484d75;
  border-radius: 5px;
  font-size: 1.2em;
  color: var(--label-primary);
  padding: 10px 20px;
  margin-right: 10px;
}
.line {
  border-top: 1px solid #ffffff;
  border-bottom: none;
  opacity: 0.1;
  margin: 10px 0 25px 0;
}
.line-section {
  border-bottom: 1px solid #4d4f53;
  padding-bottom: 24px;
  margin-bottom: 25px;
}
.rating-comment {
  font-size: 1.4em;
  font-weight: bold;
  color: var(--label-primary);
}
.rating-comment > div {
  padding: 15px;
  font-weight: 400;
  background: var(--box-up);
  color: #999999;
  border-radius: 5px;
  min-height: 80px;
}
.totalizer {
  flex: 1;
  height: 94px;
  border-bottom: 5px solid #99accc26;
}
.totalizer:nth-child(2),
.totalizer:nth-child(3) {
  margin-right: 20px;
}
.totalizer:first-child {
  padding-bottom: 10px;
}
.totalizer.negative > div > p,
.totalizer.negative > p {
  color: #e25569;
}
.totalizer > div > p {
  font-size: 2em;
  font-weight: 900;
  color: #8e8e90;
  margin-right: 10px;
}
.totalizer > p {
  font-size: 1.2em;
  color: #999999;
}
.totalizer > p::first-letter {
  text-transform: uppercase;
}
.totalizer.global:first-child {
  flex: 0 31%;
  margin-right: 20px;
  border-bottom: 5px solid #c7915b;
}
.totalizer.global.negative {
  border-bottom: 5px solid #e25569;
}
.totalizer.global.negative > div > p,
.totalizer.global.negative > p {
  color: #e25569;
}
.totalizer.global > div > p {
  font-size: 2.5em;
  font-weight: bold;
  color: var(--yellow-one);
  margin-right: 10px;
}
.totalizer.global > p {
  font-size: 1.5em;
  font-weight: bold;
  margin-top: -1px;
  opacity: 1;
  color: var(--yellow-one);
}
.title-rating {
  font-family: 'Rubik', sans-serif;
  font-size: 2em !important;
  color: #999999;
}

.title-rating + .box {
  margin-bottom: 20px;
}

.drawer-order-number {
  font-weight: bold;
  font-size: 1.6em;
  color: #aaaaab;
}
.drawer-order-number + p {
  font-size: 1.2em;
  color: #bfbfbf;
  opacity: 0.7;
}
.drawer-order-average {
  font-size: 1.4em;
  font-weight: bold;
  color: #ffb366;
}
.drawer-order-average > i {
  margin-left: 5px;
}
.drawer-order-average.negative {
  color: #e25569;
}
.show-more {
  font-size: 1.2em;
  color: #fff;
  cursor: pointer;
}
.show-more + div {
  background-color: #fff;
  height: 1px;
  width: 54px;
  margin-left: auto;
  margin-top: 3px;
  cursor: pointer;
}
.tag {
  background: var(--box-up);
  padding: 4px 12px;
  margin-left: 10px;
  border-radius: 5px;
  color: #aaaaaae6;
  font-size: 14px;
  line-height: 17px;
  position: relative;
}
.tag.period {
  padding-right: 30px;
}
.tags-mobile .tag {
  margin-left: 0 !important;
  margin-top: 10px;
  padding: 10px 15px;
}
.tags-mobile .tag i {
  float: right;
}
.remove-filter {
  margin-left: 12px;
  font-size: 13px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
}
.toggle-tags {
  margin-right: 10px;
  font-size: 1.3em;
  color: var(--default);
}

.search-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

@media (max-width: 991px) {
  .totalizer {
    align-items: center;
    padding: 10px;
    height: auto;
    border-bottom: 5px solid #99accc26;
  }
  .totalizer:nth-child(2),
  .totalizer:nth-child(3) {
    margin-right: 10px;
  }
  .totalizer.global:first-child {
    flex: 1 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .totalizer > div {
    margin-bottom: 15px !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .totalizer > div > p {
    font-size: 1.4em;
    margin-bottom: 5px;
    margin-right: 0;
  }
  .totalizer > p {
    font-size: 1em;
  }
  .tag {
    font-size: 12px;
  }
  .tag.period {
    margin-top: 15px;
    width: 100%;
    margin-left: 0;
  }
  .title-rating {
    font-size: 1.6em !important;
    margin-bottom: 25px !important;
    margin-top: -5px;
  }
  .totalizer.global {
    width: 100%;
  }
  .totalizer.global > div > p {
    margin-right: 0;
    margin-bottom: 8px;
  }
  .totalizer.global > p {
    font-size: 1.2em;
  }
  .order-number {
    font-size: 1.4em !important;
  }
  .order-number + p {
    font-size: 1em;
  }
  .order-average {
    padding: 5px 0;
    font-size: 1.2em;
  }
  .rating-category > p {
    font-size: 1.2em;
  }
  .category-rating-item {
    font-size: 1em;
    margin-right: 5px;
  }
  .rating-comment {
    font-size: 1.2em;
  }
  .rating-comment > div {
    font-size: 1em;
  }
}
</style>
